module.exports = __webpack_public_path__ + "img/tu05.9740b952.png";